var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconAntelope = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.506 14.429h5a7.029 7.029 0 0 1-2.143-5.715A6.486 6.486 0 0 1 14.077 3c.658 0 1.429 0 1.429.714 0 .715-.643.715-1.429.715-1.428 0-2.142 2.857-2.142 4.285 0 2.857 5 6.429 5 6.429L21.22 18l-2.857 5a46.629 46.629 0 0 0-5.714-5 66.1 66.1 0 0 0-7.143-2.143.757.757 0 0 1 0-1.428z",
    fill: "#1A202C",
    fillRule: "nonzero"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconAntelope, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-antelope.391924f6.svg";
export { ForwardRef as ReactComponent };